import React, { useState } from "react";

import { Typography } from "@material-ui/core";
import {
  ExpandLess,
  ExpandMore
} from "@material-ui/icons";

import Members from "./members";

import styles from "./styles";

function TopBar({title, uid}) {

  const [open, setOpen] = useState(false);

  const classes = styles();

  return (
    <div className={classes.root}>
      <div className={classes.staticBar}
        onClick={e => setOpen(o => !o)}
      >
        <Typography className={classes.title} variant="h6">
          {title}
        </Typography>
        {open
          ? <ExpandLess className={classes.icon} />
          : <ExpandMore className={classes.icon} />
        }
      </div>

      {open && <Members chatUid={uid} open={open} />}
    </div>
  )
}

export default TopBar;
